import "../../assets/css/fullscreen.css";

import { useParams } from "react-router-dom";

import MeetingTopBar from "../meeting-top-bar/meeting-top-bar";
import MainTopBar from "../navbar-menu";
import UserPanel from "../navbar-menu/components/user-panel";
import { MobileHeader } from "../navbar-menu/mobile-header";
import SideMenu from "../side-menu/SideMenu";

const MainLayout = ({ children }) => {
  const { meetingId } = useParams();

  return (
    <div className="container">
      <SideMenu />
      <div className="layout__box">
        <MobileHeader />
        <div className="navbar-menu">
          <div className="navbar-menu-left">{meetingId ? <MeetingTopBar /> : <MainTopBar />}</div>
          <div className="navbar-menu-right flex h-52">
            <div className="items-on-rigth__profile">
              <UserPanel />
            </div>
          </div>
        </div>
        <div className="layout__main">{children}</div>
      </div>
    </div>
  );
};

export default MainLayout;
